import * as Select from '@radix-ui/react-select';

import { DropdownItemWithChildren } from '~/chords/Select/components/DropdownTreeSingleSelect/components/DropdownItemWithChildren';
import type {
  InternalDropdownOption,
  OptionTemplateComponent,
  RadixUiProps,
} from '~/chords/Select/components/DropdownTreeSingleSelect/types';

interface DropdownItemsProps extends RadixUiProps {
  depth: number;
  options: InternalDropdownOption[];
  searchQuery?: string;
  selectedOption?: InternalDropdownOption;
  onSelectOption?: (option: InternalDropdownOption) => void;
  onExpandOption?: (
    option: InternalDropdownOption,
    isExpanded: boolean,
  ) => void;
  showCheckIcon?: boolean;
  OptionTemplate?: OptionTemplateComponent;
}

export function DropdownItems({
  depth,
  options,
  searchQuery,
  selectedOption,
  onSelectOption,
  onExpandOption,
  showCheckIcon,
  OptionTemplate,
  radix = {},
}: DropdownItemsProps) {
  return (
    <Select.Group {...radix.selectGroup}>
      {options.map((option) => (
        <DropdownItemWithChildren
          key={option.value}
          depth={depth}
          option={option}
          selectedOption={selectedOption}
          onSelectOption={onSelectOption}
          onExpandOption={onExpandOption}
          showCheckIcon={showCheckIcon}
          searchQuery={searchQuery}
          OptionTemplate={OptionTemplate}
          radix={radix}
        />
      ))}
    </Select.Group>
  );
}

DropdownItems.displayName = 'DropdownItems';
